<template>
    <div>
        <div class="text-[24px] text-white font-semibold mb-3 flex justify-between">
            Purchase Order AI Prompts
            <button @click="create()" class="text-white bg-theme-green hover:bg-green-600 py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer">
                <svg fill="currentColor" width="32" height="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"></path>
                </svg>
            </button>
        </div>
        <block-loading v-if="table.loading" />
        <list-table v-else :table="table" @dragged="sortedRow" @paginate="paginate" @draggable="true" >
            <template v-slot:tableRow="{data}">
                <td class="p-2 w-[100%_-_240px]"><div class="bg-theme-grey px-[8px] py-[10px] rounded w-full">{{ data.title }}</div></td>
                <td class="p-2 text-right  w-[140px]">
                    <button @click.prevent="editPrompt(data)" class="cursor-pointer rounded-md bg-white text-theme-green py-2 px-4 hover:bg-theme-darkgreen hover:text-white">
                        Edit Prompt
                    </button>
                </td>
                <td class="p-2  w-[100px]">
                    <button @click.prevent="deletePrompt(data)" class="cursor-pointer rounded-md bg-white text-theme-red py-2 px-4 hover:bg-theme-red hover:text-white">
                        Delete
                    </button>
                </td>
            </template>
        </list-table>
        <AddEdit v-if="addEdit.modal" :data="addEdit.data" @close="close" />
    </div>
</template>

<script>
import {defineComponent, ref} from "vue"
import {mapActions} from "vuex";
import { useSnackbar } from "vue3-snackbar";
import ListTable from '@/components/table/listTable'
import AddEdit from './AddEdit'
import Env from '@/env';
import Helpers from '@/helpers';
import PoAiApi from '@/controllers/PoAi'

export default defineComponent({
    components: {
        ListTable,
        AddEdit
    },
    setup() {
        const snackbar = useSnackbar();
        const addEdit = ref({
            modal: false,
            data: {}
        })
        const table = ref({
            loading: false,
            draggable: true,
            rows: [],
            totalRecords: 0,
            page: 1,
            sortable: {
                order: "title",
                sort: "asc",
            },
            pagination: false,
            pagesize: Env.defaultPageSize,
            pageOptions: Env.pageList,
        });

        return {snackbar, addEdit, table}
    },
    async mounted(){
        this.table.loading = true;
        await this.fetchList(this.table.page);
        this.table.loading = false;
        this.emitter.on("refresh-po-ai-list", data => {
            this.fetchList(this.table.page);
        });
    },
    beforeDestroy() {
        this.emitter.off('refresh-po-ai-list')
    },
    methods: {
        async fetchList(page) {
            this.table.loading = true;
            let res = await PoAiApi.fetchAll(false, page, this.table.pagesize);
            this.table.loading = false;
            this.table.rows = res.data.payload.aiPrompts
            this.table.totalRecords = res.data.payload.totalRecords
            this.table.page = page
        },
        async sortedRow(rows){
            let ids = rows.map(each => each.id)
            this.va_spinner(true)
            await PoAiApi.sortPoAI({promptIds: ids})
            this.va_spinner(false)
        },
        paginate(page){
            this.fetchList(page)
        },
        create(){
            this.addEdit = {
                modal: true,
                data: {}
            }
        },
        editPrompt(obj){
            this.addEdit = {
                modal: true,
                data: obj
            }
        },
        deletePrompt(obj){
            this.confirmNew('Delete Prompt', 'Are you sure you want to delete this prompt?','Yes', 'bg-theme-green text-white','Cancel', 'border border-white text-white', false).then(async () => {
                this.va_spinner(true);
                let res = await PoAiApi.delete(obj.id);
                this.va_spinner(false);
                    this.snackbar.add({
                    type: 'info',
                    text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
                if(res.status == 200 ) {
                    this.emitter.emit("refresh-po-ai-list", true);
                    this.close()
                }
            }).catch({})
        },
        close(){
            this.addEdit.modal = false
        },
        ...mapActions({
            va_spinner: 'spinner/setSpinner',
        })
    }
})
</script>